export default __webpack_public_path__ + "static/media/Dates_Ajouter.1851a9c0.png";